import './index.styl';
import template from './index.jst';

import { View } from 'backbone.marionette';
import Radio from 'backbone.radio';

import {
	Preloader,
	ErrorsModal,
	isTablet,
	isMobile
} from '../../../utils';

const SQUAD_NICKNAMES = {
	500011: 'broncos',
	500010: 'bulldogs',
	500012: 'cowboys',
	500723: 'dolphins',
	500022: 'dragons',
	500031: 'eels',
	500003: 'knights',
	500014: 'panthers',
	500005: 'rabbitohs',
	500013: 'raiders',
	500001: 'roosters',
	500002: 'sea-eagles',
	500028: 'sharks',
	500021: 'storm',
	500023: 'wests-tigers',
	500004: 'titans',
	500032: 'warriors',
	// Women IDs
	500470: 'broncos',
	500690: 'titans',
	500691: 'knights',
	500692: 'eels',
	500471: 'dragons',
	500469: 'roosters'
}


const tippingChannel = Radio.channel('tipping');

export class TipView extends View {

	get template() {
		return template;
	}

	ui() {
		return {
			radio: '.js-radio-tip',
			btn_margin_more: '.js-margin-more',
			btn_margin_less: '.js-margin-less',
			input_margin: '.js-predict-margin-value',
			btn_game_info: '.js-game-more-info'
		}
	}

	events() {
		const isDesktop = !isTablet() && !isMobile();
		const events = isDesktop ? {
			'mouseenter': 'onMatchMouseOn',
			'mouseleave': 'onMatchMouseOut',
		} : {};

		return {
			'click @ui.radio': 'onMakeBet',
			'mousedown @ui.btn_margin_more': 'increaseMarginRecursively',
			'mouseup @ui.btn_margin_more': 'clearTimeoutId',
			'mouseout @ui.btn_margin_more': 'clearTimeoutId',
			'mousedown @ui.btn_margin_less': 'decreaseMarginRecursively',
			'mouseup @ui.btn_margin_less': 'clearTimeoutId',
			'mouseout @ui.btn_margin_less': 'clearTimeoutId',
			'blur @ui.input_margin': 'validateMarginValue',
			'click @ui.btn_game_info': 'toggleGameInfo',
			...events
		}
	}

	get className() {
		if (!this._className) {
			this._className = "tip-container";
		}

		return this._className;
	}

	set className(className) {
		this._className = `tip-container ${className}`;
	}

	updateElementClassList() {
		this.$el
			.removeClass('tip-container tip-selected-left tip-selected-right')
			.addClass(this.className);

		return this;
	}

	onMatchMouseOn(){
		tippingChannel.trigger('add:highlight:squads', [
			this.model.get('home_squad_id'),
			this.model.get('away_squad_id'),
		]);
	}

	onMatchMouseOut(){
		tippingChannel.trigger('remove:highlight:squads');
	}

	updateViewClassNameField() {
		const {
				predict_winner_squad_id,
				home_squad_id,
				is_disabled,
				is_completed,
				is_correct,
				is_autogenerate
			} = this.model.attributes,

			is_selected = predict_winner_squad_id !== 0,
			is_selected_left = home_squad_id === predict_winner_squad_id;

		let classNameList = [];

		if (is_selected) {
			classNameList.push(`tip-selected-${ is_selected_left ? 'left' : 'right' }`);
		}

		if (is_completed && !is_autogenerate) {
			classNameList.push(`tip-selected-${ is_correct ? 'correct' : 'incorrect' }`);
		}

		if (is_disabled) {
			classNameList.push('tip-with-score');
		}

		this.className = classNameList.join(' ');

		return this;
	}

	onBeforeRender() {
		this.updateViewClassNameField()
			.updateElementClassList();
	}

	initialize() {
		const { game_info } = this.options;


		if(!this.model.get('is_soo')) {
			this.model.set('is_soo', false);
		}
		if(!this.model.get('is_postponed')) {
			this.model.set('is_postponed', 0);
		}
		if(!this.model.get('predict_winner_squad_id')){
			this.model.set('predict_winner_squad_id', 0)
		}


		this.model.set({ is_game_info_opened: false, is_mobile: isMobile() });
		const away_id = this.model.get('away_squad_id'),
			home_id = this.model.get('home_squad_id'),
			round = this.model.get('round'),
			home_name = SQUAD_NICKNAMES[home_id],
			away_name = SQUAD_NICKNAMES[away_id]
		let full_match_url =
			`https://www.nrl.com/draw/nrl-premiership/2023/
			round-${round}/${home_name}-v-${away_name}/`

		this.model.set({ full_match_url });


		// this.listenTo(this.model, 'change:predict_winner_squad_id', this.render);
		this.listenTo(this.model, 'change:is_game_info_opened', this.render);
		this.listenTo(game_info, 'get:formguide:errors', ErrorsModal.show);
	}

	increaseMarginRecursively() {
		this.increaseMargin();
		this.timeoutId = setTimeout(() => this.increaseMarginRecursively(), 150);
	}

	decreaseMarginRecursively() {
		this.decreaseMargin();
		this.timeoutId = setTimeout(() => this.decreaseMarginRecursively(), 150);
	}

	updateMargin(value) {
		this.ui.input_margin.val(value);
		this.model.set({ predict_margin: value });
		this.trigger('make:bet');

		return this;
	}

	increaseMargin() {
		const
			predict_margin = this.model.get('predict_margin'),
			value = predict_margin < 99 ? predict_margin + 1 : predict_margin;

		this.updateMargin(value);
	}

	decreaseMargin() {
		const
			predict_margin = this.model.get('predict_margin'),
			value = predict_margin > 0 ? predict_margin - 1 : predict_margin;

		this.updateMargin(value);
	}

	clearTimeoutId() {
		clearTimeout(this.timeoutId);
		return this;
	}

	validateMarginValue({ target }) {
		let value = target.value.trim();
		const is_valid = target.checkValidity() && value !== '';

		if (!is_valid) {
			value = '0';
		}

		target.value = value;

		const is_changed = value !== String(this.model.get('predict_margin'));

		if (!is_changed) {
			return;
		}

		this.model.set({ predict_margin: parseInt(value, 10) });

		this.trigger('make:bet');
	}

	onMakeBet(e) {
		this.model.set({
			predict_winner_squad_id: parseInt(e.target.value, 10)
		});

		this.trigger('make:bet');

		this.onBeforeRender();
	}

	async toggleGameInfo() {
		const
			{ game_info } = this.options,
			is_game_info_opened = this.model.get('is_game_info_opened');

		if (!is_game_info_opened) {
			Preloader.show();

			await game_info.getData();

			game_info.setHeadToHeadPercentage();

			this.model.set({
				game_info: game_info.toJSON()
			});

			Preloader.hide();
		}

		this.model.set({
			is_game_info_opened: !is_game_info_opened
		});
	}
}

export default TipView;